import { useCallback } from "react";
import useRole from "providers/RoleProvider/useRole";
import CanDoService from "services/CanDoService";
import { CanDoActions } from "../../types/CanDoActions";
import useOrganisation from "contexts/OrganisationContext/useOrganisation";

function useCanDo(): (actionName: CanDoActions) => boolean;
function useCanDo(actionName: CanDoActions): boolean;
function useCanDo(actionName?: CanDoActions) {
  const role = useRole();
  const organisation = useOrganisation();

  const check = useCallback(
    (action: CanDoActions) => {
      return CanDoService.check(action, {
        role,
        organisation,
        remoteConfig: {},
      });
    },
    [role, organisation]
  );

  if (typeof actionName !== "undefined") return check(actionName);

  return check;
}

export default useCanDo;
